import * as Sentry from '@sentry/nextjs';

type SourceString = `${string}.${Source}`;

export const Module = {
  FINOPS: 'finops',
  NOTIFICATIONS: 'notifications',
  SANDBOXES: 'sandboxes',
} as const;

export type Module = (typeof Module)[keyof typeof Module];

export enum Source {
  COMPONENT = 'component',
  HOOK = 'hook',
  PROVIDER = 'provider',
  FUNCTION = 'function',
}

type Primitive = number | string | boolean | bigint | symbol | null | undefined;

type CaptureModuleExceptionProps = {
  module: Module;
  source: SourceString;
  error: unknown;
  context?: Record<string, Primitive>;
  extra?: Record<string, Primitive>;
};

export function captureModuleException({
  module,
  source,
  error,
  context,
  extra,
}: CaptureModuleExceptionProps): void {
  Sentry.withScope((scope) => {
    scope.setTag('module', module);

    scope.setContext('data', {
      source,
      ...(context ?? {}),
    });

    if (extra) {
      scope.setExtras(extra);
    }

    Sentry.captureException(error);
  });
}
